<template>
  <ListItem>
    <template>
      <div class="main">
        <span class="ske" :class="{'forced-ske': forcedSke}">
          {{ name || category }}
        </span>
      </div>
      <span class="info ske" :class="{'forced-ske': forcedSke}">
        <svg v-if="category" class="mr-1" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
        </svg>
        
        {{ category ? "Category menu" : path}}
      </span>
    </template>

    <template #after>
      <svg xmlns="http://www.w3.org/2000/svg" class="close ske" :class="{'forced-ske': forcedSke}" width="18" height="18" viewBox="0 0 20 20" fill="currentColor" @click.prevent.stop="$emit('delete')">
        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
      </svg>
    </template>
  </ListItem>
</template>

<script>

import ListItem from "src/layout/ListItem.vue"

export default {
  components: {
    ListItem,
  },
  props: {
    forcedSke: Boolean,
    name: {
      type: String,
      required: false,
    },
    category: {
      type: String,
      required: false,
    },
    path: {
      type: String,
    },
  },
}

</script>

<style scoped>

svg {
  color: var(--black-70);
}

</style>
